import { PERMS } from 'permissions';
import { AMODULO_FRONT, AMODULO_FROTAS, AMODULO_PARTNER } from 'consts';

/* Catálogo de permissões do módulo Adm Partner */
export const ADMPARTNER_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
                        label: 'Agenda'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
                        label: 'Usuários Partner'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Frotas */
export const FROTAS_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: 'Abastecimento',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_BOMBA_INTERNA,
                        label: 'Bombas internas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_CATEGORIA_COMBUSTIVEL,
                        label: 'Categoria de combustível'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_COMBUSTIVEL,
                        label: 'Combustível'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_TANQUE_INTERNO,
                        label: 'Tanques internos'
                    }
                ]
            },
            {
                grupo: 'Fretamento contínuo',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_CLIENTE,
                        label: 'Cliente'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA,
                        label: 'Linha'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA_CLIENTE,
                        label: 'Linhas de clientes'
                    }
                ]
            },
            {
                grupo: 'Manutenção',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_GRUPO_SERVICO,
                        label: 'Grupo de serviços de manutenção'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_INSTRUCAO_PREVENTIVA,
                        label: 'Instruções de manutenção preventiva'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_MOTIVO,
                        label: 'Motivos de manutenção'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_SERVICO,
                        label: 'Serviços de manutenção'
                    }
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_CONDICAO,
                        label: 'Condições de pneus'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_FABRICANTE,
                        label: 'Fabricantes de pneus'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_MEDIDA,
                        label: 'Medidas de pneus'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_MODELO,
                        label: 'Modelos de pneus'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_PNEU,
                        label: 'Pneus'
                    }
                ]
            },
            {
                grupo: 'Veículos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
                        label: 'Marcas de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
                        label: 'Modelos de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
                        label: 'Opcionais de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
                        label: 'Tipos de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
                        label: 'Veículos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FROTAS_ATUALIZAR_SALDO_ESTOQUE_TANQUE_COMBUSTIVEL,
                        label: 'Atualizar saldo de estoque do tanque de combustível'
                    },
                    {
                        permCode: PERMS.FROTAS_INATIVAR_VEICULO,
                        label: 'Inativar veículo'
                    },
                    {
                        permCode: PERMS.FROTAS_VISUALIZAR_ABA_RH_CADASTRO_FUNCIONARIO,
                        label: 'Visualizar aba RH no cadastro de funcionários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: 'Abastecimentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_ACERTO_ESTOQUE_COMBUSTIVEL,
                        label: 'Acerto de estoque de combustível'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_AJUSTE,
                        label: 'Ajuste de abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_CTF,
                        label: 'CTF'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
                        label: 'Lançar abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_NF_COMBUSTIVEL,
                        label: 'NF de combustível'
                    }
                ]
            },
            {
                grupo: 'Documentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_FUNCIONARIO,
                        label: 'Documentos de funcionários'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_VEICULO,
                        label: 'Documentos de veículos'
                    }
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_PNEU_PARADA_MOVIMENTACAO,
                        label: 'Parada para movimentação'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_MAO_OBRA_EXTERNA,
                        label: 'Agrupar/gerar contas a pagar de mão de obra externa'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ALERTA_EMAIL_OS_PREVENTIVA,
                        label: 'Alerta de e-mails de OSs preventivas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_FRETAMENTO_CONTINUO,
                        label: 'Fretamento contínuo'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_GERACAO_OS_PREVENTIVA,
                        label: 'Geração de OSs preventivas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_MAPA_VEICULO,
                        label: 'Mapa de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_MULTA,
                        label: 'Multas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_PARCELAMENTO_PAGAR,
                        label: 'Parcelamento a pagar'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_REQUISICAO,
                        label: 'Requisições'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FROTAS_ALTERAR_ABASTECIMENTO,
                        label: 'Alterar abastecimento'
                    },
                    {
                        permCode: PERMS.FROTAS_CANCELAR_REQUISICAO,
                        label: 'Cancelar requisição'
                    },
                    {
                        permCode: PERMS.FROTAS_CONFIRMAR_REQUISICAO,
                        label: 'Confirmar requisição'
                    },
                    {
                        permCode: PERMS.FROTAS_CONTROLAR_OCORRENCIA,
                        label: 'Controlar ocorrências'
                    },
                    {
                        permCode: PERMS.FROTAS_DEVOLVER_REQUISICAO,
                        label: 'Devolver requisição'
                    },
                    {
                        permCode: PERMS.FROTAS_IGNORAR_CONTROLE_RIGIDO_ABASTECIMENTO,
                        label: 'Ignorar controle rígido de abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_INSERIR_ABASTECIMENTO_HODOMETRO_INFERIOR_ATUAL,
                        label: 'Inserir abastecimento com hodômetro inferior ao atual'
                    },
                    {
                        permCode: PERMS.FROTAS_REABRIR_OS_ENCERRADA,
                        label: 'Reabrir OS encerrada'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: 'Abastecimentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_COMPARATIVO_MES,
                        label: 'Comparativo de abastecimentos entre meses'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_FICHA_MERCADORIA,
                        label: 'Ficha de mercadoria'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_LISTAGEM,
                        label: 'Listagem de abastecimentos'
                    }
                ]
            },
            {
                grupo: 'Fretamento contínuo',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PERIODO,
                        label: 'Fretamentos por período'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PLANEJADO_REALIZADO_MES,
                        label: 'Fretamento planejado/realizado mês'
                    }
                ]
            },
            {
                grupo: 'Manutenção',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_EXTRATO_CUSTO_VEICULO,
                        label: 'Extrato de custos do veículo'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_LISTAGEM,
                        label: 'Listagem de manutenções'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_REALIZADA,
                        label: 'Manutenções realizadas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VENCER,
                        label: 'Preventivas a vencer'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_DETALHADA,
                        label: 'Preventivas detalhadas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_ABERTO,
                        label: 'Preventivas em aberto'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_GERAL,
                        label: 'Preventivas gerais'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_CANCELADO,
                        label: 'Serviços cancelados'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_REALIZADO,
                        label: 'Serviços realizados'
                    }
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO,
                        label: 'Movimentação de pneu'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO_VEICULO,
                        label: 'Movimentação de veículo'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_APURACAO_VEICULO,
                        label: 'Apuração por veículo'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_OCORRENCIA,
                        label: 'Ocorrências'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo único de permissões - indexado pelo código do módulo */
export const PERMISSIONS_CATALOG = {
    [AMODULO_FROTAS]: FROTAS_PERMISSIONS_CATALOG,
    [AMODULO_PARTNER]: ADMPARTNER_PERMISSIONS_CATALOG
};

/* Mapeia o prefixo da rota para o código do módulo */
export const MODULO_POR_PREFIXO_ROTA = {
    front: AMODULO_FRONT,
    frotas: AMODULO_FROTAS,
    admpartner: AMODULO_PARTNER
};